import React from "react";
import { Download } from "lucide-react";
import { IconButton } from ".";

interface FileDownloadButtonProps {
  handleDownload: () => void;
  isDisabled?: boolean;
  buttonText?: string;
}

const FileDownloadButton: React.FC<FileDownloadButtonProps> = ({ handleDownload, isDisabled = false, buttonText }) => {
  if (!buttonText) {
    return <IconButton onClick={handleDownload} icon={"DOWNLOAD"} disabled={isDisabled} />;
  }

  return (
    <button
      onClick={handleDownload}
      type="button"
      disabled={isDisabled}
      className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-secondary-700 bg-white border border-secondary-200 rounded-lg transition-all duration-200 hover:bg-secondary-50 hover:border-secondary-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-secondary-200"
    >
      <Download className="w-4 h-4" />
      {buttonText}
    </button>
  );
};

export { FileDownloadButton };
